/* eslint-disable react/display-name*/
import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Grid,
  Typography,
} from "@mui/material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import HomeIcon from "@mui/icons-material/Home";
import MoneyIcon from "@mui/icons-material/Money";
import RefreshIcon from "@mui/icons-material/Refresh";

import db from "../../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import GenericReportViewer from "./../../reports/GenericReportViewer";
import PrintIcon from "@mui/icons-material/Print";
import { StringUtils } from "../../../utils/StringUtils";
import ChequePrint from "../ChequePrint/ChequePrint";
import VendorAcctPaymentTypeSelector from "./VendorAcctPaymentTypeSelector";
import VendorAccountingCrud2 from "./VendorAccountingCrud2";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function VendorAccountingList(props) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [searchStr, setSearchStr] = useState("");
  const [selectedRowFromGrid, setSelectedRowFromGrid] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [transactionMode, setTransactionMode] = useState("");
  const [showCrud, setShowCrud] = useState(false);
  const [mode, setMode] = useState("");
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 155) / 32)
  );
  const { t } = useTranslation();
  const translate = t;

  useEffect(() => {
    loadData();
  }, []);

  // function addCashTransactions() {
  //   let transactionMode = "Cash";
  //   biRef.child.showVendorAccountingCrudWindow(transactionMode, null);
  // }
  function addCashTransactions() {
    let transactionMode = "Cash";
    biRef.child.showVendorAccountingPaymentType(transactionMode, null);
  }

  // function addBankTransactions() {
  //   let transactionMode = "Bank";
  //   biRef.child.showVendorAccountingCrudWindow(transactionMode, null);
  // }
  function addBankTransactions() {
    let transactionMode = "Bank";
    biRef.child.showVendorAccountingPaymentType(transactionMode, null);
  }
  function onViewButtonClicked(row) {
    setSelectedRowFromGrid(row.tableData[row.rowIndex].id);
    setTransactionMode(row.tableData[row.rowIndex].transactionMode);
    setShowCrud(true);
    setMode("view");

    switch (row.tableData[row.rowIndex].paymentType) {
      case "1":
        setPaymentType({ id: 1, name: "Invoice against" });
        break;
      case "2":
        setPaymentType({ id: 2, name: "Own account" });
        break;
      case "3":
        setPaymentType({ id: 3, name: "Advance payment" });
        break;
      case "4":
        setPaymentType({ id: 4, name: "Partial payment" });
        break;
    }
  }

  function onPrintClicked(row) {
    let paramsList = [
      {
        key: "accountingTransactionId",
        value: row.tableData[row.rowIndex].id,
      },
    ];

    biRef.genericReportView.showGenericReportViewer(
      "reports/generic/vendor_payment_voucher",
      paramsList,
      "Vendor Transaction",
      "v2"
    );
  }

  function onChequePrint(row) {
    biRef.chequeRef.showChequePrintWindow(
      row.tableData[row.rowIndex],
      "vendor"
    );
  }

  async function loadData() {
    console.log("loadData");
    loadByRest(0, rowLimitPerPage, "[]", "[]");
    //loaadByDB();
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    console.log("loadByRest");
    setIsLoading(false);
    sort = '[{id:"transactionDate2",desc:true}]';
    const result = await API.get(
      "/api/v1/getacctransactions/VENDOR?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );

    var arr = result.headers["content-range"].split("/");

    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data);
    setIsLoading(false);
  }

  async function loaadByDB() {
    db.transactions.toArray(function (data) {
      setData(data);
    });
  }

  async function onTableChange(tableState) {
    let sort = "[]";
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    let search = "[]";
    if (tableState.searchText) {
      let str = "[";
      str = str + '{id:"fromLedgerName",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"toLedgerName",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"voucherNumber",value:"' + tableState.searchText + '"}';

      str = str + "]";
      search = str;
    }
    loadByRest(tableState.page, tableState.rowsPerPage, sort, search);
  }

  const options = {
    serverSide: true,
    filterType: "dropdown",
    download: false,
    viewColumns: false,
    filter: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyHeight: getWindowDimensions().height - 162,
    rowsPerPage: Math.round((getWindowDimensions().height - 162) / 33),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 162) / 33),
      10,
      15,
      50,
      100,
    ],
    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={translate("Refresh Data")}>
            <IconButton
              size="small"
              color="secondary"
              onClick={transactionsListRefresh}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title={translate("Add Cash Transaction")}>
            <Button color="primary" onClick={addCashTransactions}>
              <MoneyIcon />
              Cash<sup>+</sup>
            </Button>
          </Tooltip>

          <Tooltip title={translate("Add Bank Transaction")}>
            <Button color="secondary" onClick={addBankTransactions}>
              <AccountBalanceIcon />
              Bank<sup>+</sup>
            </Button>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  function getPaymentType(value) {
    let type = "";
    if (value === "1") {
      type = "Full";
    } else if (value === "2") {
      type = "Partial";
    } else if (value === "3") {
      type = "Advance";
    } else if (value === "4") {
      type = "Manual";
    }
    return type;
  }

  const [option, setOption] = useState(options);

  const columns = [
    {
      name: "voucherNumber",
      label: translate("Voucher Number"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "transactionDate2",
      label: translate("Date"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formatDate(new Date(value), 1);
        },
      },
    },
    {
      name: "paymentType",
      label: translate("Type"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return getPaymentType(value);
        },
      },
    },
    {
      name: "fromLedgerName",
      label: translate("From"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "toLedgerName",
      label: translate("To"),
      options: {
        filter: false,
        sort: true,
      },
    },

    {
      name: "amount",
      label: translate("Amount"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value < 0 ? (
            <div>
              {StringUtils.formattedNumber(
                value * -1,
                props.context.store.currencyDecimal
              )}
            </div>
          ) : (
            <div>
              {StringUtils.formattedNumber(
                value * 1,
                props.context.store.currencyDecimal
              )}
            </div>
          );
        },
      },
    },

    {
      name: "discount",
      label: translate("Discount"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "actualAmount",
      label: translate("Actual Amount"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({ align: "right" }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            {tableMeta.tableData[tableMeta.rowIndex].transactionMode ===
              "Bank" && (
              <Button
                onClick={() => onChequePrint(tableMeta, updateValue, value)}
                color="secondary"
                style={{
                  marginRight: 35,
                  height: 17,
                  width: 30,
                  alignText: "right",
                }}
              >
                {translate("Cheque")}
                <PrintIcon
                  style={{
                    marginLeft: 5,
                  }}
                />
              </Button>
            )}
            {tableMeta.tableData[tableMeta.rowIndex]
              .accountingTransactionItemList && (
              <Button
                onClick={() =>
                  onViewButtonClicked(tableMeta, updateValue, value)
                }
                color="secondary"
                style={{
                  margin: 0,
                  padding: 0,
                  height: 17,
                  width: 27,
                  alignText: "right",
                }}
              >
                {translate("View")}
              </Button>
            )}
            {tableMeta.tableData[tableMeta.rowIndex]
              .accountingTransactionItemList && (
              <Button
                onClick={() => onPrintClicked(tableMeta, updateValue, value)}
                color="secondary"
                style={{
                  margin: 0,
                  padding: 0,
                  height: 17,
                  width: 27,
                  alignText: "right",
                }}
              >
                {translate("Print")}
              </Button>
            )}
          </div>
        ),
      },
    },
  ];

  function transactionsListRefresh() {
    loadData();
  }

  var biRef = {};

  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={
              <Typography variant="h6">
                {translate("Vendor Transaction List")}
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
      <GenericReportViewer
        biRef={biRef}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
      ></GenericReportViewer>
      <VendorAcctPaymentTypeSelector
        biRef={biRef}
        type={props.type}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
        onRefresh={transactionsListRefresh}
      ></VendorAcctPaymentTypeSelector>
      {showCrud && (
        <VendorAccountingCrud2
          setSelectedRowFromGrid={setSelectedRowFromGrid}
          selectedRowFromGrid={selectedRowFromGrid}
          biRef={biRef}
          showCrud={props.showCrud}
          transactionMode={transactionMode}
          paymentType={paymentType}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          context={props.context}
          setShowCrud={setShowCrud}
          mode={mode}
          onRefresh={transactionsListRefresh}
        ></VendorAccountingCrud2>
      )}
      <ChequePrint
        biRef={biRef}
        showMessage={props.showMessage}
        showProgress={props.showProgress}
        hideProgress={props.hideProgress}
        setAlert={props.setAlert}
      ></ChequePrint>
    </Grid>
  );
}
